import loading from '../helpers/loading'
import collectionPerPage from '../helpers/collectionPerPage'

import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    ...collectionPerPage.state,
    purchaseError: null
  },
  mutations: {
    ...loading.mutations,
    ...collectionPerPage.mutations,
    purchaseError: (state, { error }) => (state.purchaseError = error)
  },
  getters: {
    ...loading.getters,
    ...collectionPerPage.getters
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/purchases/index.js